function fn_comp_reference() {
    var $fn = $(".comp_reference"),
        $slider = $fn.find("[data-slider]"),
        $slider_autoplay = $slider.data("slider"),
        $slider_prev = $fn.closest("section").find("[data-slider-prev]"),
        $slider_next = $fn.closest("section").find("[data-slider-next]");

    $slider.slick({
        infinite: false,
        autoplay: true,
        autoplaySpeed: $slider_autoplay,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        speed: 500,
        touchMove: true,
        draggable: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $slider_prev.on("click", function() {
        $slider.slick("slickPrev");
    });

    $slider_next.on("click", function() {
        $slider.slick("slickNext");
    });
}